import * as React from "react";
import get from "lodash/get";

import "./TotalRewards.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface TotalRewardsProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class TotalRewards extends ComponentBase<TotalRewardsProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const totalRewards = get(rewardStats, "totalCredits");

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`TotalRewards-text  TotalRewards-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "TotalRewards-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {totalRewards}
      </div>
    );
  }
}
